import * as Common from '@/agiles/common';

export enum mfaFlags
{
  initialize = 0,  //初期化
  send_sms = 1, //SMS認証
  duplicate_session =2, //セッション重複
  update_session = 3, //再設定
  update_sms = 4,
  reset_sms = 5,  //SMS認証解除
  reset_confirm = 6, //SMS認証解除の確認
  reset_invalid = 7, //SMS認証解除の確認  
}
export enum authenticationFlags 
{
    none, //未初期化
    session, //都度認証
    sms, //sms認証
}

export class MFASetting extends Common.ObjectBase {
  constructor() {
    super('MFASetting');
  }
  public authenticationFlag: authenticationFlags;
  public smsTelNo: string;
}

export class SMSSendCodeQuery extends Common.Query {
  constructor(telNo : string){
        super('SMSSendCodeQuery', null);
        this.telNo = telNo;
    }
    public telNo: string;
} 

export class SMSValidateCodeQuery extends Common.Query {
  constructor(telNo : string,authenticationCode: string,hash:string,initialize: boolean){
        super('SMSValidateCodeQuery', null);
        this.telNo = telNo;
        this.authenticationCode = authenticationCode;
        this.hash = hash;
        this.initialize = initialize;
    }

    public telNo: string;
    public authenticationCode: string;
    public hash:string;
    public initialize: boolean;
} 

export class MFAInvalidateQuery extends Common.Query {
  constructor(){
        super('MFAInvalidateQuery', null);
    }
} 

export class MFAResetMailQuery extends Common.Query {
  constructor(){
        super('MFAResetMailQuery', null);
    }
} 

export class MFAValidateResetTokenQuery extends Common.Query {
  constructor(resetToken :string ){
        super('MFAValidateResetTokenQuery', null);
        this.resetToken =resetToken;
    }
    public resetToken :string;
}

export class MFACreateTokenQuery extends Common.Query {
  constructor(){
        super('MFACreateTokenQuery', null);
    }
} 

export class MFASettingQuery extends Common.Query {
  constructor(){
        super('MFASettingQuery', new Common.ModelBinder(MFASetting));
    }
} 

export class MFALogoutQuery extends Common.Query {
  constructor(){
        super('MFALogoutQuery', null);
    }
} 